import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class NotificationList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: [],
      // user: {},
      // updated: false,
      // searched: false,
      loading: true
    };

    this.error = this.error.bind(this);
    this.insertNotice = this.insertNotice.bind(this);
    this.deleteNotice = this.deleteNotice.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  insertNotice() {
    this.props.history.push("/notice/form");
  }

  // O ERRO ACONTECE QUANDO NUM GRUPO DE 3 AVISOS, EU EXCLUO O PENULTIMO. ISSO PODE SER PROBLEMA NO FOR. Consolar nos métodos de erro pra saber qual foi
  deleteNotice(dropRowKeys) {
    dropRowKeys.forEach(key => {
      axios
        .post(`${URL.api}communication/notice/delete/${key}`, null, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          // eslint-disable-next-line react/no-access-state-in-setstate
          let newList = [...this.state.list];
          // let index;
          for (let i = 0; i < newList.length; i++) {
            if (newList[i].id === key) {
              // index = i;
              newList.splice(i, 1);
              break;
            }
          }
          // newList.splice(index, 1);
          this.setState(
            {
              list: newList
            },
            () => {
              this.forceUpdate();
            }
          );
        });
    });
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    axios
      .post(
        `${URL.api}communication/notice/list`,
        { created_by: this.props.user.user.id },
        {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(
        resp => {
          this.setState(
            () => ({
              list: null
            }),
            () => {
              if (resp.data.data.length === 0) {
                this.setState(() => ({
                  list: [],
                  loading: false
                }));
              } else {
                this.setState(
                  () => ({
                    list: resp.data.data,
                    loading: false
                  }),
                  () => {
                    this.forceUpdate();
                  }
                );
              }
            }
          );
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Breadcrumb current={this.props.currentRoute} />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Row>
            {this.state.list ? (
              <div id="list">
                <DataTable
                  list={this.state.list}
                  path="/notice/edit/"
                  title="Avisos"
                  header={[
                    { name: "id", denomination: "ID" },
                    { name: "title", denomination: "Título" },
                    { name: "description", denomination: "Description" },
                    { name: "user_name", denomination: "Autor" }
                  ]}
                  insert
                  delete
                  insertAction={this.insertNotice}
                  deleteAction={this.deleteNotice}
                />
              </div>
            ) : (
              <Loading />
            )}
          </Row>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationList);
